import { db } from "../../connection";
import { applicationError } from "../../../../redux/actions/error";
import { countries } from "countries-list";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  where,
  updateDoc,
} from "@firebase/firestore";
import logger from "../../../../utils/logger";

let countrtyNameCodeMap = {};
Object.keys(countries).forEach((key) => {
  countrtyNameCodeMap[key] = countries[key].name;
});

export function fbCreateChant(groupId, data) {
  return new Promise((resolve) => {
    const docRef = doc(collection(db, "group", groupId, "chants"));

    setDoc(docRef, {
      ...data,
      createdOn: parseInt(Date.now() / 1000),
      isPublished: true,
    })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        let message = "There was an error creating the chant for the group";
        applicationError({
          message,
          intensity: "high",
          err,
          errorCode: "firebase",
        });
      });

    let groupDocRef = doc(db, "group", groupId);

    getDoc(groupDocRef).then((doc) => {
      if (doc.exists()) {
        let sortOrderChantIds = doc.data().sortOrderChantIds || [];
        sortOrderChantIds.push(docRef.id);

        updateDoc(groupDocRef, { sortOrderChantIds })
          .then(() => {
            logger.log("Document successfully updated!");
          })
          .catch((error) => {
            logger.error("Error updating document: ", error);
          });
      }
    });
  });
}

export async function fbGetParentGroupChants(parentGroupId, isPublished) {
  try {
    if (!parentGroupId) {
      return [];
    }

    const parentChants = [];

    const chantsQuery = query(
      collection(db, "group", parentGroupId, "chants"),
      where("type", "==", "global"),
      where("isPublished", "==", isPublished)
    );

    const chantsSnapshot = await getDocs(chantsQuery);

    chantsSnapshot.docs.forEach((doc) => {
      parentChants.push({ ...doc.data(), id: doc.id });
    });

    return parentChants;
  } catch (error) {
    logger.error("Error fetching parent group chants:", error);
    return [];
  }
}

async function getParentGlobalChants(groupId, isPublished, currentGroupType) {
  try {
    const groupDoc = await getDoc(doc(db, "group", groupId));
    const groupData = groupDoc.data();
    const parents = groupData.parents || [];

    if (parents.length === 0) {
      return [];
    }

    const parentGroupId = parents[0];
    const chantsQuery = query(
      collection(db, "group", parentGroupId, "chants"),
      where("type", "==", "global"),
      where("isPublished", "==", isPublished)
    );

    const chantsSnapshot = await getDocs(chantsQuery);
    const parentChants = [];

    chantsSnapshot.docs.forEach((doc) => {
      const chantGroups = doc.data().groups || [];
      let shouldShowChant = false;

      if (chantGroups.includes("global")) {
        shouldShowChant = true;
      } else if (chantGroups.includes("Official Groups")) {
        shouldShowChant = currentGroupType === "Official Supporters Group";
      } else if (chantGroups.includes(groupId)) {
        shouldShowChant = true;
      }

      if (shouldShowChant) {
        parentChants.push({ ...doc.data(), id: doc.id });
      }
    });

    return parentChants;
  } catch (err) {
    logger.error("Error fetching parent global chants:", err);
    return [];
  }
}

export async function fbGetChants(groupId, isPublished, dashboard) {
  try {
    // Get group chants
    const groupChantsQuery = query(
      collection(db, "group", groupId, "chants"),
      where("isPublished", "==", isPublished)
    );

    const groupChantsSnapshot = await getDocs(groupChantsQuery);
    let groupChants = [];

    groupChantsSnapshot.docs.forEach((doc) => {
      if (
        dashboard === "admin" &&
        (!doc.data().type ||
          (doc.data().type !== "global" &&
            Array.isArray(doc.data().groups) &&
            doc.data().groups.includes(groupId)))
      ) {
        groupChants.push({ ...doc.data(), id: doc.id });
      }
      if (
        dashboard === "clubadmin" &&
        !!doc.data().type &&
        doc.data().type === "global"
      ) {
        groupChants.push({ ...doc.data(), id: doc.id });
      }
    });

    let parentChants = [];
    if (dashboard !== "clubadmin") {
      const groupDoc = await getDoc(doc(db, "group", groupId));
      const currentGroupType = groupDoc.data().groupType;
      parentChants = await getParentGlobalChants(
        groupId,
        isPublished,
        currentGroupType
      );
    }

    return [...groupChants, ...parentChants];
  } catch (err) {
    logger.error("There was an error fetching chants for the group");
    return [];
  }
}

export function fbGetChant(groupId, docId) {
  return new Promise((resolve) => {
    getDoc(doc(db, "group", groupId, "chants", docId))
      .then((querySnapshot) => {
        if (querySnapshot.exists()) {
          resolve({ ...querySnapshot.data() });
        } else {
          resolve();
        }
      })
      .catch((err) => {
        let message = "There was an error fetching chant for the group";
        applicationError({
          message,
          intensity: "low",
          err,
          errorCode: "firebase",
        });
      });
  });
}

export function fbUpdateChant(groupId, docId, data) {
  return new Promise((resolve) => {
    const docRef = doc(db, "group", groupId, "chants", docId);
    setDoc(docRef, data, { merge: true })
      .then(() => {
        resolve();
      })
      .catch((err) => {
        let message = "There was an error updating chant for the group";
        applicationError({
          message,
          intensity: "high",
          err,
          errorCode: "firebase",
        });
      });
  });
}

export function fbDeleteChant(groupId, docId) {
  return new Promise((resolve) => {
    const docRef = doc(db, "group", groupId, "chants", docId);
    deleteDoc(docRef)
      .then(() => {
        // let message = "There was an error deleting chant for the group"
        // store.dispatch(applicationError({ message, intensity: 'low', show: true, err: {}, errorCode: 'firebase-modal' }))
        resolve();
      })
      .catch((err) => {
        let message = "There was an error deleting chant for the group";
        applicationError({
          message,
          intensity: "low",
          show: true,
          err,
          errorCode: "firebase-modal",
        });
      });
  });
}
